export default "__VITE_ASSET__CcxHfrmm__"